import FrameFatigueAPI from 'api/frame-fatigue.api';
import { BaseHandler } from './base.handler';
import { updateLoadingState } from 'store/app.slice';

export default class FrameFatigueHandler extends BaseHandler {
  private readonly api: FrameFatigueAPI;

  constructor() {
    super();
    this.api = new FrameFatigueAPI();
  }

  async getOverview(startDate: string, endDate: string): Promise<any> {
    this.dispatch(updateLoadingState(true));
    try {
      const data = await this.api.getOverview(startDate, endDate);
      return data;
    } catch (_) {
      this.handleError(
        'An error occurred while fetching frame fatigue overview.'
      );
    } finally {
      this.dispatch(updateLoadingState(false));
    }
    return null;
  }

  async getCriticalAssets(
    startDate: string,
    endDate: string,
    bumperId?: string
  ): Promise<any> {
    this.dispatch(updateLoadingState(true));
    try {
      const data = await this.api.getCriticalAssets(
        startDate,
        endDate,
        bumperId
      );
      return data;
    } catch (_) {
      this.handleError('An error occurred while fetching critical assets.');
    } finally {
      this.dispatch(updateLoadingState(false));
    }
    return null;
  }

  async getAssetDetail(
    bumperId: string,
    startDate: string,
    endDate: string,
    selectedDate?: string
  ): Promise<any> {
    this.dispatch(updateLoadingState(true));
    try {
      const data = await this.api.getAssetDetail(
        bumperId,
        startDate,
        endDate,
        selectedDate
      );
      return data;
    } catch (_) {
      this.handleError('An error occurred while fetching asset details.');
    } finally {
      this.dispatch(updateLoadingState(false));
    }
    return null;
  }
}
